import { DatePicker, Form, Input, Modal } from 'antd';
import { useCreateApiKeyMutation } from '@app/services';
import { useState } from 'react';
import KeyRevealModal from './KeyRevealModal';

interface Props {
    appName: string;
    open: boolean;
    onClose: () => void;
}

export default function CreateKeyModal({ appName, open, onClose }: Props) {
    const [form] = Form.useForm();
    const [createKey, { isLoading }] = useCreateApiKeyMutation();
    const [revealKey, setRevealKey] = useState<string | null>(null);

    const handleCreate = async () => {
        const values = await form.validateFields();
        const result = await createKey({
            appName,
            name: values.name,
            expiresAt: values.expiresAt?.toISOString(),
        }).unwrap();
        setRevealKey(result.key);
        form.resetFields();
    };

    if (revealKey) {
        return (
            <KeyRevealModal
                apiKey={revealKey}
                open={true}
                onClose={() => {
                    setRevealKey(null);
                    onClose();
                }}
            />
        );
    }

    return (
        <Modal
            title="Create API Key"
            open={open}
            onOk={handleCreate}
            onCancel={onClose}
            okText="Create"
            confirmLoading={isLoading}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Key Name"
                    rules={[{ required: true, message: 'Please enter a name for this key' }]}
                >
                    <Input placeholder="e.g. Production Key" />
                </Form.Item>
                <Form.Item name="expiresAt" label="Expiration (optional)">
                    <DatePicker showTime style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Modal>
    );
}
